import React, { useState } from "react";
import { List, X } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const upload = (path) => `https://rghtnow.com/wp-content/uploads/${path}`;

const navItems = [
  { key: "about", label: "About Us", to: "/about-page" },
  { key: "services", label: "Services", to: "/services" },
  { key: "vendors", label: "Vendors & Delivery Partners", to: "/vendors-delivery-partners" },
  { key: "advertise", label: "Advertise With Us", to: "/advertise-with-us" },
  { key: "contact", label: "Contact Us", to: "/contact-us" },
];

const RghtnowMarketingHeader = ({ active }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="rght-header">
      <div className="container d-flex align-items-center justify-content-between">
        <Link to="/home" className="rght-logo" aria-label="RGHT NOW home" onClick={closeMenu}>
          <img src={upload("2025/11/rghtnow-header-logo.png")} alt="RGHT NOW" />
        </Link>
        <button
          type="button"
          className="rght-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          {menuOpen ? <X size={25} /> : <List size={25} />}
        </button>
        <nav className={`rght-nav ${menuOpen ? "is-open" : ""}`}>
          {navItems.map((item) => (
            <Link
              className={active === item.key ? "active" : undefined}
              key={item.key}
              to={item.to}
              onClick={closeMenu}
            >
              {item.label}
            </Link>
            ))}
          <div className="rght-header-actions">
            <Link className={`rght-nav-cta ${active === "onboard" ? "active" : ""}`} to="/onboard-your-store" onClick={closeMenu}>
              <span>Onboard Your Store</span>
              <img src={upload("2026/05/shop-rghtnow.svg")} alt="" />
            </Link>
            <Link className={`rght-nav-cta rght-nav-cta--delivery ${active === "delivery" ? "active" : ""}`} to="/become-a-delivery-partner" onClick={closeMenu}>
              <span>Join as Delivery Partner</span>
              <img src={upload("2023/09/Group-304.svg")} alt="" />
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default RghtnowMarketingHeader;
